// The owned category/products grid: 1408px maximum, 16px page padding,
// 1/2/3/4 columns and 16px gaps (24px from xl). Keep in sync with its CSS.
export const fytofarmGridImageSizes =
  '(min-width: 1440px) 334px, (min-width: 1280px) calc(25vw - 26px), ' +
  '(min-width: 1024px) calc(25vw - 20px), (min-width: 768px) calc((100vw - 64px) / 3), ' +
  '(min-width: 640px) calc(50vw - 24px), calc(100vw - 32px)';
